export const integrationKeys = {
  all: ['content-integrations'] as const,
  logs: (contentId?: string) =>
    [...integrationKeys.all, 'logs', contentId] as const,
  routingConfig: (contentId: string) =>
    [...integrationKeys.all, 'routingConfig', contentId] as const,
}
